export function firstEntry<T>(input: T | T[]): T | undefined {
  return Array.isArray(input) ? input[0] : input;
}
